
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/q",
      function () {
        return require("private-next-pages/q/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/q"])
      });
    }
  